import HTMLReactParser from "html-react-parser"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function ProductsServicesCinemaOverview({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-cinema-detail-overview" ref={trigger}>
      <div className="py-main container">
        <div className="row">
          <div className="col-md-6 col-title">
            <h2 className={`title ${anim(1, "fadeInUpGradient")}`}>
              {data && data[`title_${locale}`]}
            </h2>
          </div>
          <div className="col-md-6 col-text">
            <div className={`text ${anim(2)}`}>
              {convertHtmlToReact(data[`description_${locale}`])}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsServicesCinemaOverview
